import cipher from './../cipher';

class configuratorService {

    constructor($http) {
        'ngInject';

        this.$http = $http;
        this.apiMainUrl = '/ajax/';

        this.userLogged = false;
    }

    setUserLogged() {
        this.$http.get(
            `${this.apiMainUrl}users/getUserLogged`
        ).then(
            response => {
                this.userLogged = response.data;
            },
            response => {
                console.log(`Error while checking user logged!`);
            }
        );
    }

    getPrice(model, quantity) {
        const encoded = cipher.encode({
            data: model,
            quantity: quantity
        });

        console.log('configuratorService::getPrice', model, quantity);

        return this.$http.post(
            `${this.apiMainUrl}configurator/getPrice`,
            encoded
        );
    }

    getPrintsPrice(model, quantity) {
        const encoded = cipher.encode({
            data: model,
            quantity: quantity
        });

        return this.$http.post(
            `${this.apiMainUrl}configurator/prints/getPrice`,
            encoded
        );
    }

    getMaterials() {
        return this.$http.get(
            `${this.apiMainUrl}configurator/getMaterials`
        );
    }

    addToCart(model, quantity, svg) {
        const encoded = cipher.encode({
            data: model,
            svg: svg,
            quantity: quantity
        });

        console.log('configuratorService::addToCart', model, quantity);

        return this.$http.post(
            `${this.apiMainUrl}cart/addConfiguratorItemToCart`,
            encoded
        );
    }

    printsAddToCart(model, quantity, uploadFile, comments) {
        const encoded = cipher.encode({
            data: model,
            quantity: quantity,
            file: uploadFile,
            comments: comments
        });

        console.log('configuratorService::printsAddToCart', model, quantity, uploadFile, comments);

        return this.$http.post(
            `${this.apiMainUrl}cart/addConfiguratorPrintsItemToCart`,
            encoded
        );
    }
}

export default configuratorService;